import Api from "./Api";

export default {
  AddCategory(payload) {
    return Api().post("/api/checklist/addcategory", payload);
  },
  GetCategories(payload) {
    //return Api().get(`/api/checklist/getcategories?payload.limit + '&currentPage=' + payload.currentPage`)
    return Api().get(
      `/api/checklist/getcategories?limit=${payload.limit}&currentPage=${payload.currentPage}&orderBy=${payload.orderBy}&columnName=${payload.columnName}`
    );
  },
  GetCategories2() {
    return Api().get("/api/checklist/getcategories");
  },
  GetCategory(payload) {
    return Api().post("/api/checklist/getcategories", payload);
  },
  EditCategory(payload) {
    return Api().post("/api/checklist/editcategory", payload);
  },
  GetCinemas() {
    return Api().get("/api/checklist/getcinemaslist");
  },
  AddChecklist(payload) {
    return Api().post("/api/checklist/addchecklist", payload);
  },
  GetChecklists(payload) {
    return Api().get(
      "/api/checklist/getchecklists?limit=" +
        payload.limit +
        "&currentPage=" +
        payload.currentPage +
        "&columnName=" +
        payload.columnName +
        "&orderBy=" +
        payload.orderBy +
        "&searchValue=" +
        payload.searchValue
    );
  },
  GetChecklistData(payload) {
    return Api().post("/api/checklist/getchecklists", payload);
  },
  EditChecklist(payload) {
    return Api().post("/api/checklist/editchecklist", payload);
  }
};



// WEBPACK FOOTER //
// ./src/services/ChecklistService.js